/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPresignedUrl} from '../api'

 export const useQueryGetPresignedUrl = createReactQueryHook('getPresignedUrl', getPresignedUrl)
